// Events
export const ANALYTICS_EVENT_PREVIEW_LAUNCH = 'preview_launch'

// Event Types
export const ANALYTICS_EVENT_BUTTON_CLICK = 'button-click'
export const ANALYTICS_EVENT_PAGE_LOAD = 'page-load'
export const ANALYTICS_EVENT_CLICK = 'click'

// Default data
export const ANALYTICS_PAGE_LOAD_DATA = {
  brand: 'msg-sphere',
  business_unit: 'entertainment',
  experience: 'msg-sphere-web',
  experience_section: 'global'
}

// Link Modules
export const ANALYTICS_LINK_MODULE_GLOBAL_NAV = 'global-navigation'
export const ANALYTICS_LINK_MODULE_HERO = 'hero'
export const ANALYTICS_LINK_MODULE_FILTER = 'filter'
export const ANALYTICS_LINK_MODULE_VIDEO = 'video'
export const ANALYTICS_LINK_MODULE_CTA = 'cta'
export const ANALYTICS_LINK_MODULE_HEADLINER = 'headliner-announcement'
export const ANALYTICS_LINK_MODULE_LATEST_NEWS = 'latest-news'

//Link Locations
export const ANALYTICS_LINK_LOCATION_HEADER = 'header'
export const ANALYTICS_LINK_LOCATION_BODY = 'body'
export const ANALYTICS_LINK_LOCATION_FOOTER = 'footer'
export const ANALYTICS_LINK_LOCATION_FORM = 'form'

//Link id Types
export const ANALYTICS_LINK_ID_CATEGORY = 'category'
export const ANALYTICS_LINK_ID_LOCATION = 'location'

//Page Type
export const PAGE_TYPE_HOME = 'homepage'
export const PAGE_CONTENT_MGMT = 'content_mgmt'

//GTM Constants
export const CTA_CLICK_EVENT = 'cta_click_event'
export const NAV_DRAWER = 'nav drawer'
export const HOME_PAGE_VIDEO = 'home page video'

//Venues
export const EXOSPHERE = 'exosphere'
